import { Camera, Trash2, Loader2, Save, ImageIcon, Type } from "lucide-react";
import { PLH_HERO_EYEBROW, PLH_HERO_HEADLINE, PLH_HERO_SUB, PLH_IMG_ALT, TIP_REMOVE_IMAGE } from "../../lib/constants";

export default function AdminHeroEditor({ readOnly = false, hero, setHero, uploading, handleImageUpload, handleRemoveImage, saving, handleSaveHero }) {
  return (
    <fieldset data-id="admin-hero" disabled={readOnly} className="space-y-8 animate-in fade-in slide-in-from-bottom-2 duration-500">
      <div className="grid lg:grid-cols-5 gap-8">
        <div className="lg:col-span-2 space-y-6">
          <div className="bg-white border border-fendi p-6 sticky top-24">
            <p className="eyebrow mb-6 flex items-center gap-2 text-champagne"><ImageIcon size={16} /> Visual da Capa</p>
            <div className="relative group w-full aspect-[16/10] bg-fendi/5 overflow-hidden border border-fendi/20 shadow-inner">
              {hero?.bg_image ? (
                <img src={hero.bg_image} alt="Hero Preview" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-warmgray/40"><ImageIcon size={48} strokeWidth={1} /></div>
              )}
              <label className={`absolute inset-0 bg-softblack/0 ${readOnly ? '' : 'group-hover:bg-softblack/40 cursor-pointer'} transition-all flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 text-white`}>
                {!readOnly && hero?.bg_image && (
                  <button
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleRemoveImage("hero"); }}
                    className="absolute top-4 right-4 bg-white/10 hover:bg-destructive p-2 rounded-full transition-all"
                    title={TIP_REMOVE_IMAGE}
                  >
                    <Trash2 size={16} />
                  </button>
                )}
                {!readOnly && (uploading.hero ? <Loader2 className="animate-spin" /> : <><Camera size={24} className="mb-2" /><span className="text-[10px] uppercase tracking-widest font-medium">Trocar Imagem</span></>)}
                {!readOnly && <input type="file" className="hidden" accept="image/*" onChange={e => handleImageUpload(e, "hero")} disabled={uploading.hero} />}
              </label>
            </div>
            <div className="mt-6 space-y-4">
              <div className="bg-offwhite p-4 border-l-2 border-champagne">
                <p className="text-[10px] text-warmgray leading-relaxed italic">
                  Esta é a primeira imagem que os clientes verão. Use uma foto de alta qualidade (2400px+) com tons que combinem com a marca Hub Profissional.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-3 space-y-6">
          <div className="bg-white border border-fendi p-8 shadow-sm">
            <p className="eyebrow mb-8 flex items-center gap-2 text-champagne"><Type size={16} /> Conteúdo Editorial</p>
            <div className="space-y-8">
              <label className="block">
                <span className="eyebrow text-[10px] text-warmgray">Slogan Superior (Eyebrow)</span>
                <input className="editorial-field mt-3 !text-xs tracking-[0.2em]" value={hero?.eyebrow || ""}
                  onChange={e => setHero({...hero, eyebrow: e.target.value})} placeholder={PLH_HERO_EYEBROW} />
              </label>
              <label className="block">
                <span className="eyebrow text-[10px] text-warmgray">Título de Impacto (Headline)</span>
                <textarea className="editorial-field mt-3 !text-2xl font-serif !leading-snug" rows={3} value={hero?.headline || ""}
                  onChange={e => setHero({...hero, headline: e.target.value})} placeholder={PLH_HERO_HEADLINE} />
              </label>
              <label className="block">
                <span className="eyebrow text-[10px] text-warmgray">Texto de Apoio (Subheadline)</span>
                <textarea className="editorial-field mt-3 text-base font-light !leading-relaxed text-warmgray" rows={4} value={hero?.subheadline || ""}
                  onChange={e => setHero({...hero, subheadline: e.target.value})} placeholder={PLH_HERO_SUB} />
              </label>
            </div>

            <div className="mt-12 pt-8 border-t border-fendi/10 space-y-6">
              <label className="block">
                <span className="eyebrow text-[10px] text-warmgray">Texto alternativo da imagem (acessibilidade/SEO)</span>
                <input className="editorial-field mt-3 !text-xs" value={hero?.img_alt || ""}
                  onChange={e => setHero({...hero, img_alt: e.target.value})} placeholder={PLH_IMG_ALT} />
              </label>
            </div>

            {!readOnly && (
              <div className="mt-12 flex justify-end">
                  <button onClick={handleSaveHero} disabled={saving} className="btn-primary !px-10 !py-4 shadow-lg shadow-champagne/10">
                  <Save size={16} className="mr-3" /> {saving ? "A guardar..." : "Publicar no Hero"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </fieldset>
  );
}
